import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddhitComponent } from './addhit/addhit.component';
import { AuthGuard } from './auth.guard';
import { HitsListComponent } from './hits-list/hits-list.component';
import { LoginComponent } from './login/login.component';
import { MapComponent } from './map/map.component';


const routes: Routes = [
  { path: '', redirectTo: 'hits', pathMatch: 'full'},
  { path: 'login', component: LoginComponent},
  { path: 'hits', component: HitsListComponent, canActivate: [AuthGuard]},
  { path: 'map', component: MapComponent, canActivate: [AuthGuard]},
  { path: 'hit', component: AddhitComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
